<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>

                    <b-card-header>
                        <span class="h5">RATEIOS</span>
                        <b-button class="float-right"
                            v-if="mostrarBtnAtualizarRateio"
                            variant="primary"
                            @click="abrirTabelaAjuste()"
                        >
                            <span>
                                <i class="fa fa-plus mr-2"></i> {{acao}} Rateio
                            </span>
                        </b-button>
                        <div v-if="mostrandoTabelaAjustes">
                            <b-button
                                class="float-right mr-2"
                                variant="danger"
                                @click="fecharTabelaAjuste()"
                            >
                                <i class="fa fa-times-circle-o"></i> Cancelar
                            </b-button>
                            <!-- <b-button
                                class="float-right mr-1"
                                variant="primary"
                                :disabled="desabilitarSalvar"
                                @click.stop="confirmarSalvar()"
                            >
                                <i class="fa fa-floppy-o"></i> Salvar
                            </b-button> -->
                            <btn-inserir-dotacao
                                v-if="statusPermiteAtualizar"
                                class="float-right mr-2"
                                :valorTotal="valorASerRateado"
                                :valorDisponivel="valorDisponivel"
                                @inserirRateio="inserirRateio($event)"
                                @obterUnidades="$emit('obterUnidades')"
                                @obterProjetos="$emit('obterProjetos', $event)"
                                @obterAcoes="$emit('obterAcoes', $event)"
                                :unidades="unidades"
                                :projetos="projetos"
                                :acoes="acoes"
                                :acao="acao"
                            ></btn-inserir-dotacao>
                        </div> 
                    </b-card-header>

                    <b-card-body>
                        <div v-if="!mostrandoTabelaAjustes">
                            <rateios-detalhar
                                :rateios="item.rateios"
                            ></rateios-detalhar>
                        </div>
                        <div v-if="mostrandoTabelaAjustes">
                            <tabela-ajuste-rateios
                                v-if="rateios"
                                :rateios="rateios"
                                :mostrandoTabelaAjustes="mostrandoTabelaAjustes"
                                :valorASerRateado="valorASerRateado"
                                :valorRateado="valorRateado"
                                :valorDisponivel="valorDisponivel"
                                @excluirRateio="excluirRateio($event)"
                                @atualizarRateio="atualizarRateio($event)"
                                @obterUnidades="$emit('obterUnidades')"
                                @obterProjetos="$emit('obterProjetos', $event)"
                                @obterAcoes="$emit('obterAcoes', $event)"
                                :unidades="unidades"
                                :projetos="projetos"
                                :acoes="acoes"
                            ></tabela-ajuste-rateios>
                        </div>
                    </b-card-body>

                </b-card>
            </b-col>
        </b-row>       
    </div>
</template>

<script>
import RateiosDetalhar from './RateiosDetalhar.vue';
import TabelaAjusteRateios from './TabelaAjusteRateios.vue';
import BtnInserirDotacao from './BtnInserirDotacao.vue';

export default {
    props: {
        item: {
            type: Object
        },

        temAcessoAlterarRateio: {
            type: Boolean,
        },

        statusPermiteAtualizar: {
            type: Boolean
        },

        unidades: {
            type: Array
        },

        projetos: {
            type: Array
        },

        acoes: {
            type: Array
        }
    },

    data() {
        return {
            mostrandoTabelaAjustes: false,
            mostrarModal: false,
            rateios: [],
        }
    },  

    methods: {
        abrirTabelaAjuste() {
            this.mostrandoTabelaAjustes = true
            this.resetarRateios()
        },

        fecharTabelaAjuste() {
            this.mostrandoTabelaAjustes = false
            this.resetarRateios()
        },

        // confirmarSalvar() {
        //     if (this.$route.name == 'DespesasGerais_Finalizacao_ItensDespesa_Detalhar') {
        //         this.confirmarSalvarUABS()
        //     } else {
        //         this.confirmarSalvarReq()
        //     }
        // },

        // confirmarSalvarReq() {
        //     this.$swal({
        //         title: 'Rateios',
        //         html: `Confirma as alterações no rateio?`,
        //         icon: 'warning',
        //         showCancelButton: true,
        //         confirmButtonColor: '#3085d6',
        //         cancelButtonColor: '#d33',
        //         confirmButtonText: 'Sim',
        //         cancelButtonText: 'Não'
        //     }).then(result => {
        //         if (result.value) {
        //             this.$emit('salvarRateios', this.rateios)
        //             this.fecharTabelaAjuste()
        //         }
        //     })
        // },
        
        // confirmarSalvarUABS() {
        //     this.$swal({
        //         title: 'Rateios',
        //         html: `Confirma as alterações no rateio?`,
        //         icon: 'warning',
        //         showCancelButton: true,
        //         confirmButtonColor: '#3085d6',
        //         cancelButtonColor: '#d33',
        //         confirmButtonText: 'Sim',
        //         cancelButtonText: 'Não',
        //         input: 'textarea',
        //         inputPlaceholder: 'Informe a justificativa da reprovação',
        //         inputValidator: value => {
        //             if (!value) {
        //                 return 'A justificativa da reprovação é obrigatória'
        //             }
        //         }
        //     }).then(result => {
        //         if (result.value) {
        //             let rateiosDto = {
        //                 justificativa: result.value,
        //                 rateios: this.rateios
        //             }
        //             this.$emit('salvarRateios', rateiosDto)
        //             this.fecharTabelaAjuste()
        //         }
        //     })
        // },

        resetarRateios() {
            if (this.item) {
                this.rateios = JSON.parse(
                    JSON.stringify(this.item.rateios)
                )
            }
        },

        inserirRateio(rateioDto) {
            if (
                this.rateios.filter(r => {
                    return (
                        r.codUnidade == rateioDto.codUnidade &&
                        r.codProjeto == rateioDto.codProjeto &&
                        r.codAcao == rateioDto.codAcao
                    )
                }).length > 0
            ) {
                this.erroNaInclusaoDotacao()
            } else {
                this.rateios.push(rateioDto.rateio)
                this.deveFinalizarRateio(rateioDto)
            }
        },

        erroNaInclusaoDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Já existe dotação com a unidade/projeto/ação informados`,
                icon: 'error'
            })
        },

        atualizarRateio(rateioDto) {
            for (let index = 0; index < this.rateios.length; index++) {
                const rateioAtual = this.rateios[index]
                if (
                    rateioAtual.codUnidade == rateioDto.rateio.codUnidade &&
                    rateioAtual.codProjeto == rateioDto.rateio.codProjeto &&
                    rateioAtual.codAcao == rateioDto.rateio.codAcao
                ) {
                    this.rateios[index].valor = rateioDto.rateio.valor
                    break
                }
            }
            this.deveFinalizarRateio(rateioDto)
        },

        excluirRateio(rateio) {
            for (let index = 0; index < this.rateios.length; index++) {
                const rateioAtual = this.rateios[index]
                if (
                    rateioAtual.codUnidade == rateio.codUnidade &&
                    rateioAtual.codProjeto == rateio.codProjeto &&
                    rateioAtual.codAcao == rateio.codAcao
                ) {
                    this.rateios.splice(index, 1)
                    break
                }
            }
        },

        deveFinalizarRateio(rateioDto) {
            if (rateioDto.finalizar) {
                if (rateioDto.perfil == 'REQ') {
                    this.$emit('salvarRateios', this.rateios)
                }
                else 
                {
                    let rateiosDto = {
                        justificativa: rateioDto.justificativa,
                        rateios: this.rateios
                    }
                    this.$emit('salvarRateios', rateiosDto)
                }
                this.fecharTabelaAjuste()
            }
        },
    },

    computed: {
        desabilitarSalvar() {
            return (
                this.valorDisponivel > 0 ||
                JSON.stringify(this.rateios) ==
                    JSON.stringify(this.item.rateios)
            )
        },

        valorASerRateado() {
            return this.item.valor
        },

        valorRateado() {
            if (this.item.rateios != null) {
                return Number.parseFloat(
                    this.rateios
                    .map(item => {
                        return item.valor
                    })
                    .reduce((a, b) => a + b, 0)
                    .toFixed(2)
                    )
            }
            return 0
        },

        valorDisponivel() {
            return Number.parseFloat(
                (this.valorASerRateado - this.valorRateado).toFixed(2)
            )
        },

        acao() {
            return this.rateios.length == 0 ? 'Inserir' : 'Atualizar'
        },

        mostrarBtnAtualizarRateio() {
            return this.temAcessoAlterarRateio 
                && this.statusPermiteAtualizar 
                && !this.mostrandoTabelaAjustes
                && !this.item.despesa.movimentoCompra
        }
    },

    watch: {
        item() {
            this.resetarRateios()
        }
    },

    components: {
        RateiosDetalhar,
        TabelaAjusteRateios,
        BtnInserirDotacao
    }  
}
</script>